import React from "react";
import PropTypes from "prop-types";
import { FiAlertTriangle, FiClock, FiSlash } from "react-icons/fi";
import ActionButton from "../component/Common/ActionButton";

const SubscriptionExpiredModal = ({ onClose, type, expireOn }) => {
  const handleClose = () => {
    onClose();
  };

  // Add 7 days to the expireOn date
  const accessDeniedDate = expireOn
    ? (() => {
        const d = new Date(expireOn);
        d.setDate(d.getDate() + 7);
        return d.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      })()
    : null;

  return (
    <div className="modal" style={{ display: "block", zIndex: 9999 }}>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 9998,
        }}
      />

      {/* Modal Box */}
      <div
        className="modal-content-cat_voucher6"
        style={{ position: "relative", zIndex: 9999, padding: "24px 28px 28px" }}
      >
        <span
          className="close"
          onClick={handleClose}
          style={{ position: "absolute", top: "10px", right: "16px", cursor: "pointer" }}
        >
          &times;
        </span>

        <div style={{ textAlign: "center", marginTop: "6px", marginBottom: "16px" }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              backgroundColor: type === "blocked" ? "#fbdad6" : "#caf5f5",
              color: type === "blocked" ? "#b02a1f" : "#0b6462",
            }}
          >
            {type === "inactive" && <FiAlertTriangle size={26} />}
            {type === "blocked" && <FiSlash size={26} />}
            {type === "expire" && <FiClock size={26} />}
          </span>
        </div>

        <div style={{ textAlign: "center", fontSize: "14px", color: "#444", lineHeight: 1.7 }}>
          {type === "inactive" && (
            <p style={{ marginBottom: 0 }}>
              Your subscription is currently <strong>inactive</strong> due to a pending payment or
              access restriction. Please complete the payment or contact support to reactivate.
            </p>
          )}
          {type === "blocked" && (
            <p style={{ marginBottom: 0 }}>
              Your subscription has expired and account access has been suspended.
              <br />
              Please contact your account manager or our support team to reactivate your
              subscription.
            </p>
          )}
          {type === "expire" && (
            <p style={{ marginBottom: 0 }}>
              Your subscription has expired.
              {accessDeniedDate && (
                <>
                  {" "}
                  To avoid losing access after <strong>{accessDeniedDate}</strong>,
                </>
              )}{" "}
              please renew your subscription at your earliest convenience.
            </p>
          )}
        </div>

        <div className="d-flex justify-content-center mt-3">
          <ActionButton
            text={type === "blocked" ? "OK, Got It" : "Remind Me Later"}
            type="button"
            variant="grey"
            onClick={handleClose}
            no_ml
          />
        </div>
      </div>
    </div>
  );
};

SubscriptionExpiredModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  expireOn: PropTypes.string,
};

SubscriptionExpiredModal.defaultProps = {
  expireOn: null,
};

export default SubscriptionExpiredModal;
